export interface BaseProps {
    className?: string;
    style?: string;
}

export interface SelectedOption {
    name: string;
    value: string | number;
}

export enum BadgeStyles {
    Bar = 'Bar',
    Disc20mm = '20mm Disc',
    Disc30mm = '30mm Disc',
    REnd = 'R-End',
    Shield = 'Shield',
    Star20mm = '20mm Star',
    Star30mm = '30mm Star',
    RCnr = 'R-Cnr',
}
export interface ShopifyProduct {
    id?: number;
    title?: string;
    handle?: string;
    description?: string;
    published_at?: string;
    created_at?: string;
    vendor?: string;
    type?: string;
    tags?: null | string[];
    price?: number;
    price_min?: number;
    price_max?: number;
    available?: boolean;
    price_varies?: boolean;
    compare_at_price?: number | null;
    compare_at_price_min?: number;
    compare_at_price_max?: number;
    compare_at_price_varies?: boolean;
    variants?: ShopifyProductVariant[];
    images?: string[];
    featured_image?: string;
    options?: ShopifyProductOption[];
    url?: string;
}

export interface ShopifyProductVariant {
    id: number;
    title?: string;
    options?: string[];
    option1?: string | null;
    option2?: string | null;
    option3?: string | null;
    price?: number;
    weight?: number;
    compare_at_price?: number | null;
    inventory_management?: string;
    inventory_quantity?: number;
    available?: boolean,
    sku?: number | string | null;
    requires_shipping?: boolean;
    taxable?: boolean;
    barcode?: string | null;
}

export interface ShopifyProductOption {
    name: string;
    position?: number;
    values?: string[];
}

export interface StyleMatrix {
    type: string;
    lines: number[];
}

export interface ValidStyle {
    type: string;
    valid: boolean;
}

export interface OptionSelectEvent {
    name: string;
    value: string;
    colour: string | null;
    step: number;
}